import React, { useState, useEffect } from "react";
import { formatDateToRelativeOrShortDate } from "../Helpers/utils";
import Post from "./Post";
// 1. Import useGlobalState
import { useGlobalState } from "../contexts/GlobalStateContext"; // (Adjust path if needed)

function MessageItem({ message, currentUserId }) {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const isCurrentUser = message.sender_id === currentUserId;
  const isTextMessage = !message.uuid;

  const [postData, setPostData] = useState(null);

  // 2. Get setFullScreenPost from the hook
  const { setFullScreenPost } = useGlobalState();

  useEffect(() => {
    // Fetch the embedded post if it's not a text message
    if (!isTextMessage && message.uuid) {
      const fetchPost = async () => {
        try {
          const response = await fetch(`${baseUrl}/php/fetch_post.php`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ uuid: message.uuid }),
          });

          const data = await response.json();

          if (data.success) {
            // 3. Pass the onImageClick prop to the Post component
            setPostData(data.post);
          } else {
            console.error("Failed to fetch post:", data.message);
          }
        } catch (error) {
          console.error("Error fetching post:", error);
        }
      };

      fetchPost();
    }
    // 4. Update the dependency array
  }, [isTextMessage, message.uuid, baseUrl, setFullScreenPost]);

  return (
    <div
      className={`conversation-item ${isTextMessage ? "conversation-content" : "conversation-element"
        } ${!isCurrentUser && isTextMessage ? "received" : "sent"}`}
    >
      {isTextMessage && (
        <img
          src={`profile_pics_icons/${message.sender_id}.jpg`}
          alt="Profile Picture"
          className="profile-pic"
        />
      )}

      <div className="message-content">
        <strong>{message.fullName}</strong>
        <br />
        {isTextMessage ? (
          <span>{message.content}</span>
        ) : (
          postData ? (
            <Post
              key={postData.uuid}
              post={postData}
              onImageClick={() => setFullScreenPost({
                ...postData,
                isExternalClick: true
              })}
            />
          ) : (
            <span>Loading post...</span>
          )
        )}
      </div>

      <div
        className="timestamp"
        style={{ fontSize: "small", textAlign: "right" }}
      >
        {formatDateToRelativeOrShortDate(message.created_at)}
      </div>
    </div>
  );
}

export default MessageItem;